module.exports = __webpack_public_path__ + "img/footer__logo——vi.8a3ee668.png";